// Mappings for Survey Simplification Trial
// redirectSurveyId = Survey ID of new simplified survey
// redirectChance = Percentage of customers that should see this new survey
export const mappings: {
  [key: string]: { redirectSurveyId: string; redirectChance: number }
} = {
  SV_6MtlOGAxp9i54GO: {
    redirectSurveyId: 'SV_6PrR1KhjLx4yNa6',
    redirectChance: 100,
  },
  SV_cZnMPk9qqMRo5fL: {
    redirectSurveyId: 'SV_eUJobnU0FFfC3Y2',
    redirectChance: 100,
  },
  SV_3UJeDf9c1VsHVYO: {
    redirectSurveyId: 'SV_3O8WcqD7WjIN4eW',
    redirectChance: 100,
  },
}

export const expiryDays = 45
